import { Injectable } from '@angular/core';
import {ProjectService, WmHttpService} from "@wms/services";
import {map, Observable} from "rxjs";
import {set} from "lodash-es";
import {environment, EventManagerService} from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  API_META = {
    "workspacePermissions": {
      url: environment.SERVICES_BASE_PATH + "services/studio/preferences",
      method: "GET",
      embedModeAPI: true
    },
    "projectPermissions": {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/preferences",
      method: "GET",
      embedModeAPI: true
    }
  };
  TARGET = 'ACCESSCONTROL';

  constructor(private wmHttpService: WmHttpService, private eventManager: EventManagerService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  transformBackendPref(pref: any) {
    if(pref.url) {
      let url = pref.url.split(window.location.origin)[1];
      this.eventManager.emitCacheAPIResponse({
        url         : url.replace('/studio/', ''),
        response    : pref.body,
        httpMethod  : 'GET'
      });
    }
    let newPref = {};
    for (const key in pref.body) {
      set(newPref, key, pref.body[key]);
    }
    return newPref;
  }

  getWorkspacePermissions() {
    return (this.wmHttpService.execute({target: this.TARGET, action: 'workspacePermissions', observable: true}) as Observable<any>).pipe(map(this.transformBackendPref.bind(this))).toPromise();
  }

  getProjectPermissions(projectId: string) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'projectPermissions',
      pathParams:{
        projectId: projectId
      },
      observable: true
    }) as Observable<any>).pipe(map(this.transformBackendPref.bind(this))).toPromise();
  }

  getPermissionsByProjectType(projectType: string, platformType: string) {
    return new Promise((resolve, reject) => {
      import(`./../../../assets/preferences/${projectType}/${platformType}/preferences.json`)
        .then(result => {
          resolve(result.default);
        })
        .catch(reject);
    });
  }

  getDefaultPermissions() {
    return new Promise((resolve, reject) => {
      import('./../../../assets/preferences/preferences.json')
        .then(result => {
          resolve(result.default);
        })
        .catch(reject);
    });
  }

}
